import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import DxAutocomplete from '../../dxautocomplete/components/dxautocomplete';
import ReasonOptionSelector from '../../reasonoptionselector/components/reasonoptionselector';
import codeCategoryTypes from '../../../config/codecategoryconstants';

const rootDialogStyle = {
  width: '720px',
  padding: '1em'
};

const supportingTextContainerStyle = {
  marginTop: '0.6em',
  padding: '0.1em'
};

const textAreaStyle = {
  resize: 'none',
  width: '100%',
  height: '6em'
};

const buttonContainerStyle = {
  float: 'right'
};

const inputContainerStyle = {
  marginTop: '2em'
};

const initialDialogState = {
  supportingText: '',
  selectedEncoding: null,
  selectedReasonOptions: []
};

const OverriddenDialog = withStyles({
  paper: {
    position: ['inherit', '!important']
  }
})(Dialog);

const AddDxDialog = ({
  isOpen,
  dateOfService,
  encounterId,
  supportingText,
  reasonOptions,
  addDx,
  closeDialog,
  category = codeCategoryTypes.HCC
}) => {
  const [dialogState, setDialogState] = useState({
    ...initialDialogState,
    supportingText
  });

  const [selectedReasonOptionState, setSelectedReasonOptionState] = useState([]);

  useEffect(() => {
    setDialogState({ ...initialDialogState, supportingText });
    setSelectedReasonOptionState([]);
  }, [isOpen, dateOfService, encounterId, supportingText]);

  const selectReasonOption = reasonOptionId => {
    setSelectedReasonOptionState([
      ...selectedReasonOptionState,
      reasonOptionId
    ]);
  };

  const deselectReasonOption = reasonOptionId => {
    const nextState = selectedReasonOptionState.filter(x => x !== reasonOptionId);
    setSelectedReasonOptionState(nextState);
  };

  return (
    <OverriddenDialog
      open={isOpen}
      maxWidth="lg"
      disableBackdropClick
      disableEscapeKeyDown
    >
      <div style={rootDialogStyle}>
        {/* title */}
        <div>
          <h3 style={{ textAlign: 'center' }}>Add Encoding: DX</h3>
        </div>

        {/* supporting text */}
        <div style={supportingTextContainerStyle}>
          <span>
            <strong>Supporting Text: </strong>
            <textarea
              style={textAreaStyle}
              value={dialogState.supportingText}
              onChange={e => {
                e.preventDefault();
                e.stopPropagation();
                const val = e.target.value;
                setDialogState({ ...dialogState, supportingText: val });
              }}
            />
          </span>
        </div>

        {/* reason options */}
        <ReasonOptionSelector
          reasonOptions={reasonOptions}
          selectReasonOption={selectReasonOption}
          deselectReasonOption={deselectReasonOption}
          selectedReasonOptions={selectedReasonOptionState}
          filterPredicate={x => x.reasonType === 'Approve'}
        />

        {/* autocomplete */}
        <div style={inputContainerStyle}>
          <DxAutocomplete
            dateOfService={dateOfService}
            category={category}
            selectedEncoding={dialogState.selectedEncoding}
            setSelectedEncoding={se => {
              setDialogState({ ...dialogState, selectedEncoding: se });
            }}
          />
        </div>

        {/* cancel & ok buttons */}
        <div style={buttonContainerStyle}>
          <button
            onClick={closeDialog}
          >
            Cancel
          </button>

          <button
            onClick={() => {
              const { selectedEncoding: { cmsCodeId } } = dialogState;

              addDx(
                encounterId,
                cmsCodeId,
                dialogState.supportingText,
                selectedReasonOptionState
              );
            }}
            disabled={
              dialogState.selectedEncoding === null
              || selectedReasonOptionState.length < 1
              || dialogState.supportingText.length < 1
            }
          >
            Ok
          </button>
        </div>
      </div>
    </OverriddenDialog>
  );
};

AddDxDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dateOfService: PropTypes.string.isRequired,
  encounterId: PropTypes.string.isRequired,
  supportingText: PropTypes.string.isRequired,
  reasonOptions: PropTypes.array.isRequired,
  addDx: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  category: PropTypes.number
};

export default AddDxDialog;
